export const MENU_WIDTH = 280;
